import { usePersonalDetails } from '../PersonalDetails/data';

import { ReadProfileVisibility } from './ReadProfileVisibility/ReadProfileVisibilityContainer';
import { useGetProfileVisibility2 } from './data';

export const ProfileVisibilityV2Container = () => {
  const { loading: profileVisibilityLoading, error: profileVisibilityError } =
    useGetProfileVisibility2();
  const { loading: personalDetailsLoading } = usePersonalDetails();

  const loading = profileVisibilityLoading;
  const error = profileVisibilityError;

  return (
    <ReadProfileVisibility
      loading={Boolean(loading || error)}
      personalDetailsLoading={personalDetailsLoading}
    />
  );
};
